module.exports = __webpack_public_path__ + "img/selo-corretora.945d214a.png";